import { Table, FovButton } from 'components/generic';
import { getColor } from 'utils';
import styled from 'styled-components';

export const MemberContainer = styled(Table)`
    border: 0.0625rem solid #ccc;
    border-radius: 0.25rem;
    border-color: ${props => getColor(props, 'mediumGrey')};
`;

export const AddOrganizationButton = styled(FovButton)`
       position: relative;
       width: fit-content;
       cursor: pointer;
       background-color: ${props => getColor(props, 'accent')};
       margin-right: 0;
       margin-left: auto;
       color: ${props => getColor(props, 'onPrimary')};
       &: hover {
         background-color: ${props => getColor(props, 'accentHover')};
       }
`;

export const TitleContainer = styled('div')`
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
`;

export const TitleRow = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const TitleActions = styled('div')`
    display: flex;
    align-items: center;
`;

export const TabContainer = styled('div')`
    position: relative;
    display: inline-flex;
    padding: 1rem 0;
    width: 100%;
`;

export const Tab = styled(FovButton)`
    position: relative;
    width: fit-content;
    margin: 0 0.5rem;
    background-color: ${props => {
        return getColor(props, props.selected ? 'accent' : 'onPrimary');
    }};
    &:hover {
        background-color: ${props => getColor(props, 'accentHover')};
    }

`;